import { deduplicateStrings } from "$lib/common";

export function sanitizeNameAndCompanions(name: string, companions: string[]) {
    let additionalCompanions: string[] = [];
    const plus1Regex = / \+1| \+ 1| plus1| plus 1| plus one/gi; // some write just: +1
    const plusOnes = name.match(plus1Regex) ?? [];
    name = name.replaceAll(plus1Regex, '');

    additionalCompanions = name.split(/\+|&|,|;| und | mit | plus | and | with | also /i); // eg: bob & alice with daugther
    name = additionalCompanions.shift()?.trim() ?? '';
    const nonUnicodeLettersOrNumbers = /[^\p{L}\p{N} -_]/gu;
    additionalCompanions = additionalCompanions.map((x) => x.replace(nonUnicodeLettersOrNumbers, ''));

    let sanitizedCompanions = [...additionalCompanions, ...companions];
    sanitizedCompanions = deduplicateStrings(sanitizedCompanions);
    plusOnes.forEach(() => sanitizedCompanions.push('+1')); // needs to happen after deduplication
    sanitizedCompanions = sanitizedCompanions.map((x) => x?.trim());
    sanitizedCompanions = sanitizedCompanions.filter((x) => x && !denialWords.includes(x.toLowerCase()));

    return { name, companions: sanitizedCompanions };
}

export const denialWords = ['nö', 'nein', 'no', 'nope', 'njet', 'nix', 'nichts', 'gar nichts', 'keiner', 'niemand'];